export default {
      id: "external-link-usage",
      viewBox: "0 0 17.072 16.465",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#external-link",
      toString: function () {
        return this.url;
      }
    }